import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { LoginStatus } from '@fcom/core-api/login/interfaces/login.interface';
import { AppState } from '@fcom/core';
import { loginStatus } from '@fcom/core/selectors/login.selector';
import { finShare } from '@fcom/rx';
import { unsubscribe } from '@fcom/core/utils/unsubscribe';

@Directive({
  selector: '[finShowForLoginStatus]',
  standalone: false,
})
export class ShowForLoginStatusDirective implements OnDestroy {
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private store$ = inject<Store<AppState>>(Store);

  private hasView = false;
  private subscriptions = new Subscription();

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('finShowForLoginStatus') set finShowForLoginStatus(status: LoginStatus) {
    if (!status) {
      if (!this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      }
    } else {
      if (!this.subscriptions) {
        this.subscriptions = new Subscription();
      }
      this.subscriptions.add(
        this.store$.pipe(loginStatus(), finShare()).subscribe((userStatus) => {
          if (status === userStatus) {
            if (!this.hasView) {
              this.viewContainer.createEmbeddedView(this.templateRef);
              this.hasView = true;
            }
          } else {
            this.viewContainer.clear();
            this.hasView = false;
          }
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }
}
